<div class="container">
	<div class="row"><div class="col-12">
		<h1>Lead Ranking <span class="badge bg-info align-middle">v1</span></h1>
		<p class="text-muted mb-2">Warmest prospects first — one queue for human or AI callers.</p>

		<div class="alert alert-light border fs-12 py-2">
			<i class="ri-information-line"></i>
			Warmth v1 = disposition tier + callback date + fit. Recency/attempt decay pending backend (last_dispo_date, attempt_count).
		</div>

		<div class="row g-2 align-items-end mb-3">
			<div class="col-md-5">
				<label class="form-label mb-1">Campaign</label>
				<select class="form-select" [(ngModel)]="selectedCampaign">
					<option [ngValue]="null" disabled>Select a campaign…</option>
					<option *ngFor="let c of campaigns" [ngValue]="c.id">{{ c.name }}</option>
				</select>
			</div>
			<div class="col-md-3">
				<button class="btn btn-secondary" (click)="getQueue()" [disabled]="selectedCampaign == null || loading">Rank queue</button>
			</div>
		</div>
	</div></div>

	<div class="row"><div class="col-12">
		<div class="card"><div class="card-body">
			<app-loader *ngIf="loading"></app-loader>

			<ng-container *ngIf="!loading && loaded">
				<div class="d-flex flex-wrap align-items-center mb-3" style="gap:8px;">
					<span class="badge bg-danger">Hot {{ counts.hot }}</span>
					<span class="badge bg-warning">Warm {{ counts.warm }}</span>
					<span class="badge bg-secondary">Cold {{ counts.cold }}</span>
					<span class="text-muted fs-12 ms-2">{{ excludedCount }} excluded (won / dead / DNC)</span>
				</div>

				<ngx-datatable class="material" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="25" [rows]="ranked" [scrollbarH]="true">
					<ngx-datatable-column name="#" [sortable]="false" headerClass="cell-center title-header" cellClass="cell-center" [width]="50">
						<ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>{{ rowIndex + 1 }}</ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Prospect" [sortable]="false" headerClass="title-header" [width]="200">
						<ng-template let-row="row" ngx-datatable-cell-template>
							<div style="font-weight:600">{{ fullName(row.prospect) || '—' }}</div>
							<div class="text-muted fs-11">{{ row.prospect.company_name }}</div>
						</ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Phone" [sortable]="false" headerClass="title-header" [width]="130">
						<ng-template let-row="row" ngx-datatable-cell-template>{{ row.prospect.primary_phone | phone }}</ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Tier" [sortable]="false" headerClass="cell-center title-header" cellClass="cell-center" [width]="80">
						<ng-template let-row="row" ngx-datatable-cell-template><span class="badge" [ngClass]="tierClass(row.tier)">{{ row.tierLabel }}</span></ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Why (warmth reason)" [sortable]="false" headerClass="title-header" [width]="260">
						<ng-template let-row="row" ngx-datatable-cell-template><span class="fs-12">{{ row.reason }}</span></ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Employees" [sortable]="false" headerClass="cell-center title-header" cellClass="cell-center" [width]="90">
						<ng-template let-row="row" ngx-datatable-cell-template>{{ row.employeesFit === null ? '—' : (row.employeesFit | number) }}</ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Plan assets" [sortable]="false" headerClass="cell-center title-header" cellClass="cell-center" [width]="110">
						<ng-template let-row="row" ngx-datatable-cell-template>{{ row.planAssetsFit === null ? '—' : (row.planAssetsFit | number) }}</ng-template>
					</ngx-datatable-column>
				</ngx-datatable>

				<div *ngIf="!ranked.length" class="text-muted text-center py-4">No callable prospects in this campaign (all excluded or empty).</div>
			</ng-container>
		</div></div>
	</div></div>
</div>
